import { useNavigate } from 'react-router-dom'
import logo from 'assets/svg/permission-denied.svg'
import ButtonPrimary from '../Buttons/ButtonPrimary'

type Props = {}

const PermissionDenied = ({}: Props) => {
  const navigate = useNavigate()
  return (
    <div className="permission-denied-container">
      <img src={logo} alt="Permission Denied" className="permission-denied-icon" />
      <h2 className="permission-denied-title">Permission Denied</h2>
      <p className="permission-denied-message">
        You don’t have the necessary permissions to access this page.
      </p>
      <div style={{ marginTop: '15px' }}>
        <ButtonPrimary onClick={() => navigate('/')}>Home</ButtonPrimary>
      </div>
    </div>
  )
}

export default PermissionDenied
